import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import EventBus from "../utils/EventBus";
import studentService from "../services/student.service";


export const createstudent = createAsyncThunk(
  "api/createstudent",
  async (stateData, thunkAPI) => {
    try {
      const data = await studentService.createStudent(stateData);
      return { schooldata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        if (error.response && error.response.status === 401 && error.response.status === 403) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const bulkstudent = createAsyncThunk(
  "api/bulkstudent",
  async (stateData, thunkAPI) => {
    try {
      const data = await studentService.bulkStudent(stateData);
      return { schooldata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        if (error.response && error.response.status === 401 && error.response.status === 403) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getstudent = createAsyncThunk(
  "api/getstudent",
  async (thunkAPI) => {
    try {
      const data = await studentService.getStudent();
      return { schooldata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401 && error.response.status === 403) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updatestudent = createAsyncThunk(
  "api/updatestudent",
  async ({c_id, formData}, thunkAPI) => {
    try {
      const data = await studentService.updateStudent(c_id, formData);
      return { schooldata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401 && error.response.status === 403) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deletestudent = createAsyncThunk(
  "api/deletestudent",
  async ({c_id}, thunkAPI) => {
    try {
      const data = await studentService.deleteStudent(c_id);
      return { schooldata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401 && error.response.status === 403) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState ={
    students: [],
}

const studentSlice = createSlice({
  name: "api",
  initialState,
  extraReducers: {
    [createstudent.fulfilled]: (state, action) => {
      state.students.push(action.payload.schooldata.result)
      return state;
    },
    [bulkstudent.fulfilled]: (state, action) => {
      state.students.push(action.payload.schooldata.result)
      return state;
    },
    [getstudent.fulfilled]: (state, action) => {
      state.students = action.payload.schooldata.result
      return state;
    },
    [updatestudent.fulfilled]: (state, action) => {
      const {
        arg: { c_id },
      } = action.meta;
      if (c_id) {
        state.students = state.students.map((item) =>
          item._id === c_id ? action.payload.schooldata.result[0] : item
        );
      };
    },
    [deletestudent.fulfilled]: (state, action) => {
      const {
        arg: { c_id },
      } = action.meta;
      if (c_id) {
        state.students = state.students.filter((item) => item._id !== c_id);
      };
    },
  },
});

const { reducer } = studentSlice;
export default reducer;